import {ButtonContainer, Heading, SubHeading, Text, StepWrapper} from "../components/Shared";
import StyledInput from "../components/StyledInput";
import StyledDropdown from "../components/StyledDropdown";
import StyledTextarea from "../components/StyledTextarea";
import StyledButton from "../components/StyledButton";
import useForm from "../../utils/hooks/useForm";

const Step1 = ({next}: { next: () => void }) => {

    const {
        fields,
        setField,
        validateFields
    } = useForm(['annualConsumption', 'roofAge', 'roofChange', 'roofAsbestos', 'roofPropertyType', 'isPropertyOwner','roofPanelsPosition'])

    const submit = () => {
        !validateFields() && next()
    }

    return (
        <StepWrapper>
            <Heading>INTAKE FORMULIER</Heading>
            <Text large style={{fontWeight: 600}}>We hebben nog een paar vragen...</Text>

            <Text>Bij Solease krijg je een offerte die écht bij je past. Om je van de beste besparing te voorzien,
                houden rekening met je energiebehoefte en de capaciteit op je dak.
                Om tot een persoonlijk advies te komen, hebben we nog een aantal vragen aan je. Zou je hiervoor
                onderstaande vragen willen beantwoorden zodat ik je van het beste advies kan voorzien? Alvast
                bedankt!</Text>

            <SubHeading>Jaarverbruik</SubHeading>

            <StyledInput
                label={'Wat is je exacte jaarverbruik in kWh? \nJe hebt “{INFO_FROM_OFFER_REQUEST}“ opgegeven bij je aanvraag.'}
                error={fields.annualConsumption.error}
                onChange={(value) => setField({key: 'annualConsumption', value})}/>

            <SubHeading>Dak eigenschappen</SubHeading>

            <StyledInput
                onChange={(value) => setField({key: 'roofAge', value})}
                error={fields['roofAge'].error}
                label={'Wat is de leeftijd van het dak?'}/>

            <StyledInput
                label={'Is het dak in het afgelopen jaar nog veranderd? En zo ja, wat is er veranderd?'}
                error={fields['roofChange'].error}
                onChange={(value) => setField({key: 'roofChange', value})}/>

            <StyledDropdown
                onChange={({label}) => setField({key: 'roofAsbestos', value: label})}
                error={fields['roofAsbestos'].error}
                label={'Zit er asbest in je dak? '}
                options={[
                    {label: 'Nee, er zit geen asbest in mijn dak', value: 1},
                    {label: 'Ja, er zit asbest in mijn dak en ik weet ook waar het zit', value: 2},
                    {label: 'Ja, er zit asbest in mijn dak maar ik weet niet waar het zit', value: 3}]}/>

            <SubHeading>TYPE GEBOUW</SubHeading>

            <StyledDropdown
                onChange={({label}) => setField({key: 'roofPropertyType', value: label})}
                error={fields['roofPropertyType'].error}
                label={'Betreft het pand een bedrijfspand of privé woning?'}
                options={[
                    {label: 'Bedrijfspand', value: 1},
                    {label: 'Privéwoning', value: 2},
                    {label: 'Beide', value: 3}]}/>

            <StyledDropdown
                onChange={({label}) => setField({key: 'isPropertyOwner', value: label})}
                error={fields['isPropertyOwner'].error}
                label={'Ben je eigenaar van het pand?'}
                options={[
                    {label: 'Ja', value: 1},
                    {label: 'Nee', value: 2}]}/>


            <StyledInput
                onChange={(value) => setField({key: 'roofPanelsPosition', value})}
                error={fields['roofPanelsPosition'].error}
                label={'Op welk dak(deel) had je de panelen in gedachte?'}/>

            <StyledTextarea label={'Overige opmerkingen'}/>

            <ButtonContainer style={{justifyContent: 'flex-end'}}>
                <StyledButton
                    onClick={() => submit()}
                    label={'Volgende \nstap'}/>
            </ButtonContainer>
        </StepWrapper>
    )
}

export default Step1
